import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import MyContent from "./pages/MyContent";
import VisualCreator from "./pages/VisualCreator";
import Help from "./pages/Help";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Success from "./pages/Success";
import Welcome from "./pages/Welcome";
import NotFound from "./pages/NotFound";
import Onboarding from "./pages/Onboarding";
import BestAiHumanizer from "./pages/BestAiHumanizer";
import AiTextHumanizerFree from "./pages/AiTextHumanizerFree";
import HumanizeAiTextOnline from "./pages/HumanizeAiTextOnline";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/my-content" element={<MyContent />} />
          <Route path="/visual-creator" element={<VisualCreator />} />
          <Route path="/help" element={<Help />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/success" element={<Success />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/best-ai-humanizer" element={<BestAiHumanizer />} />
          <Route path="/ai-text-humanizer-free" element={<AiTextHumanizerFree />} />
          <Route path="/humanize-ai-text-online" element={<HumanizeAiTextOnline />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
